module.exports = __webpack_public_path__ + "static/media/badCoCover.2790eb71.png";